var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNokFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 0h11.25v45h-11.25V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.875h60v11.25H0v-11.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.688 0h5.625v45h-5.625V0Z",
    fill: "#002664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.688h60v5.625H0v-5.625Z",
    fill: "#002664"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNokFlag);
export default __webpack_public_path__ + "static/media/nok-flag.59ed05f9175f982c56621e1f4a3a7fac.svg";
export { ForwardRef as ReactComponent };